"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagLabel = exports.FeatureFlag = void 0;
var FeatureFlag;
(function (FeatureFlag) {
    FeatureFlag["AIWorkflowApexClass"] = "AiWorkflowApexClass";
    FeatureFlag["AIWorkflowReleaseNotesGenerator"] = "AiWorkflowReleaseNotesGenerator";
    FeatureFlag["AIWorkflowSetupAuditTrailChangesSummary"] = "AiWorkflowSetupAuditTrailChangesSummary";
    FeatureFlag["AIWorkflowValidationRule"] = "AiWorkflowValidationRule";
    FeatureFlag["Autodoc"] = "Autodoc";
    FeatureFlag["DataDictionary"] = "DataDictionaryEnabled";
    FeatureFlag["DataSecurityApplicationStatus"] = "PulseApplicationStatus";
    FeatureFlag["DataSecurityDashboard"] = "PulseDashboard";
    FeatureFlag["DataSecurityGraphTools"] = "PulseGraphTools";
    FeatureFlag["EmbeddedDataDictionary"] = "EmbeddedDataDictionary";
    FeatureFlag["Export"] = "Export";
    FeatureFlag["Followers"] = "Followers";
    FeatureFlag["JiraIntegration"] = "JiraIntegration";
    FeatureFlag["ObjectAccessAnalyzer"] = "ObjectAccessAnalyzer";
    FeatureFlag["PardotAccountFieldSync"] = "PardotAccountFieldSync";
    FeatureFlag["PardotAutomationRuleSync"] = "PardotAutomationRuleSync";
    FeatureFlag["PardotDraftEmailSync"] = "PardotDraftEmailSync";
    FeatureFlag["PardotEmailTemplateSync"] = "PardotEmailTemplateSync";
    FeatureFlag["PardotEnabled"] = "PardotEnabled";
    FeatureFlag["PardotFormSync"] = "PardotFormSync";
    FeatureFlag["PardotImportVerboseLogging"] = "PardotImportVerboseLogging";
    FeatureFlag["PardotLandingPageSync"] = "PardotLandingPageSync";
    FeatureFlag["PardotListSync"] = "PardotListSync";
    FeatureFlag["PardotOpportunityFieldSync"] = "PardotOpportunityFieldSync";
    FeatureFlag["PardotPageActionSync"] = "PardotPageActionSync";
    FeatureFlag["PardotProfileSync"] = "PardotProfileSync";
    FeatureFlag["PardotProspectFieldSync"] = "PardotProspectFieldSync";
    FeatureFlag["PardotScheduledEmailSync"] = "PardotScheduledEmailSync";
    FeatureFlag["PardotSentEmailSync"] = "PardotSentEmailSync";
    FeatureFlag["ProfileAndPermissionSetAccessAnalyzer"] = "ProfileAndPermissionSetAccessAnalyzer";
    FeatureFlag["RecommendedActionTemplates"] = "RecommendedActionTemplates";
    FeatureFlag["SalesforceImportBuffering"] = "SfdcImportBuffering";
    FeatureFlag["SalesforceImportTolerant"] = "TolerantSfImport";
    FeatureFlag["SalesforcePageLayoutSync"] = "SfPageLayoutSync";
    FeatureFlag["SalesforceReportSync"] = "SfReportSync";
    FeatureFlag["SetupAuditTrail"] = "SetupAuditTrail";
    FeatureFlag["UseNewProfileFieldPermissionData"] = "UseNewProfileFieldPermissionData";
    FeatureFlag["UsePrivateSubnetsForTasks"] = "UsePrivateSubnetsForTasks";
    FeatureFlag["UserAccessAnalyzer"] = "UserAccessAnalyzer";
})(FeatureFlag || (exports.FeatureFlag = FeatureFlag = {}));
exports.FeatureFlagLabel = {
    aiWorkflowApexClass: 'AI Workflow for Apex Classes',
    aiWorkflowReleaseNotesGenerator: 'AI Workflow for Release Notes',
    aiWorkflowSetupAuditTrailChangesSummary: 'AI Workflow for Setup Audit Trail',
    aiWorkflowValidationRule: 'AI Workflow for Validation Rules',
    autodoc: 'Autodoc',
    dataDictionaryEnabled: 'Data Dictionary',
    embeddedDataDictionary: 'Data Dictionary Embedded Views',
    export: 'Export',
    followers: 'Followers',
    jiraIntegration: 'Jira Integration',
    objectAccessAnalyzer: 'Object Access Analyzer',
    pardotAccountFieldSync: 'Syncing Pardot Account Fields',
    pardotAutomationRuleSync: 'Syncing Pardot Automation Rules',
    pardotDraftEmailSync: 'Syncing Pardot Draft Emails',
    pardotEmailTemplateSync: 'Syncing Pardot Email Templates',
    pardotEnabled: 'Pardot Integration',
    pardotFormSync: 'Syncing Pardot Forms',
    pardotImportVerboseLogging: 'Verbose Logging for Pardot Imports',
    pardotLandingPageSync: 'Syncing Pardot Landing Pages',
    pardotListSync: 'Syncing Pardot Lists',
    pardotOpportunityFieldSync: 'Syncing Pardot Opportunity Fields',
    pardotPageActionSync: 'Syncing Pardot Page Actions',
    pardotProfileSync: 'Syncing Pardot Profiles',
    pardotProspectFieldSync: 'Syncing Pardot Prospect Fields',
    pardotScheduledEmailSync: 'Syncing Pardot Scheduled Emails',
    pardotSentEmailSync: 'Syncing Pardot Sent Emails',
    profileAndPermissionSetAccessAnalyzer: 'Profile and Permission Set Access Analyzer',
    pulseApplicationStatus: 'Data Security Application Status',
    pulseDashboard: 'Event Monitoring',
    pulseGraphTools: 'Data Security Graph Tools',
    recommendedActionTemplates: 'Recommended Action Templates',
    setupAuditTrail: 'Setup Audit Trail',
    sfPageLayoutSync: 'Salesforce Page Layouts',
    sfReportSync: 'Salesforce Reports',
    sfdcImportBuffering: 'Buffer Salesforce API calls to S3',
    tolerantSfImport: 'Tolerate Errors in Salesforce Import',
    useNewProfileFieldPermissionData: 'Use New Profile Field Permission Data',
    usePrivateSubnetsForTasks: 'Use Private Subnets for Tasks',
    userAccessAnalyzer: 'User Access Analyzer'
};
//# sourceMappingURL=FeatureFlag.js.map